import { render } from "./MessengerWidget.vue?vue&type=template&id=0ae83a0f"
import script from "./MessengerWidget.vue?vue&type=script&lang=js"
export * from "./MessengerWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__